document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      // Toggle the active class on the clicked question
      this.classList.toggle('active');
      // Toggle the visibility of the answer
      const answer = this.nextElementSibling;
      answer.classList.toggle('active');
    });
  });
});